var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-box"},[_c('div',{staticClass:"empty-icon"},[_c('el-image',{attrs:{"src":"@/assets/svgs/empty.svg"}})],1),_c('div',{staticClass:"empty-text"},[_vm._v(" "+_vm._s(_vm.emptyText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }